module.exports = __webpack_public_path__ + "img/reject@2x.4ba2811b.png";